import React, { useEffect, useState } from "react";
import { showErrorToast, showSuccessToast } from "../../../assets/toastUtils";
import { useNavigate, useParams } from "react-router-dom";
import VendorHeader from "../../../CustomComponents/Property/VendorHeader/VendorHeader";
import SideBar from "../../../CustomComponents/Property/SideBar/SideBar";
import Loader from "../../../CustomComponents/Loader/Loader";

function AddRoomVendor({ setPropertyData }) {
  const navigate = useNavigate();
  const [formErrors, setFormErrors] = useState({});
  const { id } = useParams();
  const vendorToken = localStorage.getItem("token");

  const [roomData, setRoomData] = useState({
    accommodation_id: id,
    name: "",
    content: "",
    room_view: "",
    base_adult: "",
    max_child: "",
    max_adult: "",
    max_occupancy: "",
    bed_type_information: "",
    room_type_information: "",
    room_size_information: "",
    room_area_information: "",
    mandatory_amenities: "",
    kitchen_amenities: "",
    status: "",
  });

  const validate = () => {
    const errors = {};
    if (!roomData?.name.trim()) {
      errors.name = "required";
    }
    if (!roomData?.room_type_information.trim()) {
      errors.room_type_information = "required";
    }
    if (!roomData?.bed_type_information.trim()) {
      errors.bed_type_information = "required";
    }
    if (!roomData?.room_size_information.trim()) {
      errors.room_size = "required";
    }
    if (!roomData?.room_area_information.trim()) {
      errors.room_area = "required";
    }
    if (!roomData?.base_adult.trim()) {
      errors.base_adult = "required";
    }
    if (!roomData?.max_adult.trim()) {
      errors.max_adult = "required";
    }
    if (!roomData?.content.trim()) {
      errors.content = "required";
    }
    if (!roomData?.max_child.trim()) {
      errors.max_child = "required";
    }
    if (!roomData?.max_occupancy.trim()) {
      errors.max_occupancy = "required";
    }

    setFormErrors(errors);

    return Object.keys(errors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setRoomData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const [propertyStatus, setPropertyStatus] = useState(roomData?.status || "0");

  const [selectedAmenities, setSelectedAmenities] = useState([]);

  const allAmenitiesArray = {
    "Mandatory": [
      {
        "name": "Hairdryer",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Hot & Cold Water",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Toiletries",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "TV",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Air Conditioning",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Iron/Ironing Board",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Mineral Water",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Kettle",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Closet",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Mini Bar",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Telephone",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Work Desk",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Safe",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Bathroom",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      }
    ],
    "Popular with Guests": [
      {
        "name": "Heater",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Housekeeping",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "In Room dining",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Room service",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Smoking Room",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Study Room",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Wifi",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Air Purifier",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      }
    ],
    "Bathroom": [
      {
        "name": "Bathroom Phone",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Bathtub",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Bubble Bath",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Dental Kit",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Geyser/ Water heater",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Slippers",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Shower Cap",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Hammam",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Bathrobes",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Western Toilet Seat",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Shower cubicle",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Weighing Scale",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Shaving Mirror",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Sewing kit",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Bidet",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Toilet with grab rails",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Ensuite Bathroom/Common Bay",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Jetspray",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      }
    ],
    "Room Features": [
      {
        "name": "Blackout curtains",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Center Table",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Charging points",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Couch",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Dining Table",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Fireplace",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Mini Fridge",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Sofa",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Pillow menu",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Hypoallergenic Bedding",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Living Area",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Dining Area",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Seating Area",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Fireplace Guards",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Coffee Machine",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Jacuzzi",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      }
    ],
    "Media and Entertainment": [
      {
        "name": "Smart Controls",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Sound Speakers",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Smartphone",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      }
    ],
    "Food and Drinks": [
      {
        "name": "Cake",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "BBQ Grill",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Cook & Butler Service",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      }
    ],
    "Kitchen and Appliances": [
      {
        "name": "Dishwasher",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Induction",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Kitchenette",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Refrigerator",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Washing machine",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Cook/Chef",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Cooking Basics",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Stove/Induction",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Dishes and Silverware",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Toaster",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Microwave",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Rice Cooker",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      }
    ],
    "Beds and Blanket": [
      {
        "name": "Blanket",
        "icon_url": "",
        "options": [
          "Electric",
          "Woolen"
        ]
      },
      {
        "name": "Woolen",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      }
    ],
    "Safety and Security": [
      {
        "name": "Cupboards with locks",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      }
    ],
    "Child Care": [
      {
        "name": "Child Safety Socket Covers",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      }
    ],
    "Other Facilities": [
      {
        "name": "Mosquito Net",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Newspaper",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Balcony",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Jacuzzi",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Private Pool",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Terrace",
        "icon_url": "",
        "options": [
          "yes",
          "no"
        ]
      },
      {
        "name": "Fan",
        "icon_url": "",
        "options": [
          "Ceiling",
          "Table"
        ]
      }
    ]
  }

  // const addRoomDetails = (e) => {
  //   e.preventDefault();
  //   // console.log("form submit room");

  //   const valid = validate();
  //   setTimeout(() => {
  //     setFormErrors({});
  //   }, 1000);
  //   if (!valid) {
  //     showErrorToast("Please fill the required details");
  //     return;
  //   }

  //   const raw = JSON.stringify({
  //     name: roomData.display_name,
  //     content: roomData.room_description,
  //     is_active: true,
  //     base_adults: Number(roomData.base_adult),
  //     max_children: Number(roomData.max_child),
  //     max_adults: Number(roomData.max_adult),
  //     max_occupany: Number(roomData.max_occupancy),
  //     area: Number(roomData.room_size),
  //     unit: roomData.room_size_units,
  //     type: roomData.room_type,
  //     bed: roomData.bed_type,
  //     view: roomData.room_view,
  //     selected_amenities: "1,2,3",
  //   });
  //   const requestOptions = {
  //     method: "POST",
  //     body: raw,
  //     headers: {
  //       "Content-Type": "application/json",
  //       key: "D4X50uU40Vz4pweFLEmsoiJy107iPfTD4ompprop1",
  //       Authorization: "Bearer " + localStorage.getItem("token"),
  //     },
  //     redirect: "follow",
  //   };
  //   // console.log("Payload:", raw);

  //   fetch(
  //     `${process.env.REACT_APP_APP_URL}/api/v1/vendor/accommodation-room-create/${id}`,
  //     requestOptions
  //   )
  //     .then((response) => {
  //       return response.text().then((text) => {
  //         if (!response.ok) {
  //           throw new Error("Network response was not ok: " + text);
  //         }
  //         return text;
  //       });
  //     })
  //     .then((text) => {
  //       // console.log("Response text:", text);
  //       try {
  //         const data = JSON.parse(text);
  //         if (data.success) {
  //           navigate(`/partner/all-rooms/${id}`);
  //           setRoomData(data);
  //           showSuccessToast(data.success.message || "Room Added");
  //         } else {
  //           // console.log("Error fetching data", data);
  //         }
  //       } catch (error) {
  //         console.error("Error parsing JSON:", error, text);
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching details:", error);
  //     });
  // };

  const addRoomDetails = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("accommodation_id", roomData?.accommodation_id);
    formData.append("name", roomData?.name);
    formData.append("content", roomData?.content);
    formData.append("base_adult", Number(roomData?.base_adult));
    formData.append("max_child", Number(roomData?.max_child));
    formData.append("max_adult", Number(roomData?.max_adult));
    formData.append("max_occupany", Number(roomData?.max_occupancy));
    formData.append("bed_type_information", roomData?.bed_type_information);
    formData.append("room_type_information", roomData?.room_type_information);
    formData.append("room_size_information", roomData?.room_size_information);
    formData.append("room_area_information", roomData?.room_area_information);
    // formData.append("mandatory_amenities", roomData?.mandatory_amenities);
    // formData.append("kitchen_amenities", roomData?.kitchen_amenities);

    Object.entries(selectedAmenities)?.forEach(([key, value]) => {
      const formattedKey = key.replace(/(^\w|_\w)/g, (match) =>
        match.replace('_', ' ').toUpperCase()
      );
      formData.append(formattedKey, value);
    });

    formData.append("status", propertyStatus);

    const headers = new Headers({
      Accept: "application/json",
      Authorization: `Bearer ${vendorToken}`,
    });

    const requestOptions = {
      method: "POST",
      headers: headers,
      body: formData,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/website/accomodation/rooms/create`,
        requestOptions
      );
      const result = await response.json();
      if (result.success) {
        showSuccessToast(result.message || "Room Added");
        navigate(`/vendor/property/all-rooms/${id}`);
      } else {
        showErrorToast(result.message);
      }
    } catch (error) {
      console.error("Error adding room:", error);
    }
  };

  const [loader, setLoader] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoader(false);
    }, 500);
  }, []);

  const handleAccordionToggle = (category) => {
    setOpenCategory((prevCategory) =>
      prevCategory === category ? null : category
    );
  };

  const handleCheckboxChange = (category, name) => {
    setSelectedAmenities((prev) => {
      const currentSelection = prev[category + "_amenities"]
        ? prev[category + "_amenities"].split(", ").filter(Boolean)
        : [];

      let updatedSelection;
      if (currentSelection.includes(name)) {
        updatedSelection = currentSelection.filter(
          (amenity) => amenity !== name
        );
      } else {
        updatedSelection = [...currentSelection, name];
      }

      return {
        ...prev,
        [category + "_amenities"]: updatedSelection.join(", "),
      };
    });
  };

  const [selectedCategory, setSelectedCategory] = useState(
    Object.keys(allAmenitiesArray)[0]
  );

  const [openCategory, setOpenCategory] = useState(null);

  return (
    <section>
      <div className="sidebar_main_div new_sidebar_main_div">
        <SideBar allPropertiesPage={false} />
        <div className="agent-info-container">
          <VendorHeader showSelectProperty={true} vendorProperty={false} />
          <div className="mt-20">
            <div className="flex_align_center flex_gap_20" style={{ background: 'white', borderRadius: '10px', padding: '10px 15px' }}>
              <span onClick={() => window.history.back()} className="vendor_back_btn">
                <svg xmlns="http://www.w3.org/2000/svg" style={{ margin: '0' }} width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <mask id="mask0_7233_11440" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                    <rect width="24" height="24" transform="matrix(-1 0 0 1 24 0)" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_7233_11440)">
                    <path d="M7.373 12.75H18.75C18.9628 12.75 19.141 12.6782 19.2845 12.5345C19.4282 12.391 19.5 12.2128 19.5 12C19.5 11.7872 19.4282 11.609 19.2845 11.4655C19.141 11.3218 18.9628 11.25 18.75 11.25H7.373L12.5423 6.08076C12.6909 5.93209 12.7643 5.75809 12.7625 5.55876C12.7605 5.35942 12.682 5.18217 12.527 5.02701C12.3718 4.88217 12.1962 4.80717 12 4.80201C11.8038 4.79684 11.6282 4.87184 11.473 5.02701L5.13275 11.3673C5.03908 11.4609 4.97308 11.5597 4.93475 11.6635C4.89625 11.7673 4.877 11.8795 4.877 12C4.877 12.1205 4.89625 12.2327 4.93475 12.3365C4.97308 12.4403 5.03908 12.5391 5.13275 12.6328L11.473 18.973C11.6115 19.1115 11.783 19.1823 11.9875 19.1855C12.192 19.1887 12.3718 19.1178 12.527 18.973C12.682 18.8178 12.7595 18.6397 12.7595 18.4385C12.7595 18.2372 12.682 18.0589 12.527 17.9038L7.373 12.75Z" fill="#1C1B1F" />
                  </g>
                </svg>
              </span>
              <div>
                <h4 className="vendor_top_bar_title">Add New Room</h4>
                <p className="vendor_top_bar_subtitle">Please fill the details of your property.</p>
              </div>
            </div>
            {loader ? (
              <Loader size="4em" color="#009A50" />
            ) : (
              <div className="flex-div_profile_Sec">
                <div className="w-full">
                  <form onSubmit={addRoomDetails}>
                    <div className="bg-white-div mt-10">
                      <h4>Room Info</h4>
                      <div className="input-flex mt-10">
                        <div className="w-half">
                          <label htmlFor="">
                            Name <span className="required">*</span>
                          </label>
                          <input
                            type="text"
                            onChange={handleInputChange}
                            name="name"
                            value={roomData?.name}
                            style={
                              formErrors.name && {
                                backgroundColor: "#ff000040",
                                border: "1px solid red",
                              }
                            }
                          />
                        </div>
                        <div className="w-half">
                          <label htmlFor="">
                            Room Type <span className="required">*</span>
                          </label>
                          <select
                            name="room_type_information"
                            onChange={handleInputChange}
                            id=""
                            style={
                              formErrors.room_type_information && {
                                backgroundColor: "#ff000040",
                                border: "1px solid red",
                              }
                            }
                          >
                            <option value="">Select option</option>
                            <option value="deluxe">Deluxe</option>
                            <option value="budget">Budget</option>
                            <option value="standard">Standard</option>
                            <option value="super-deluxe">Super Deluxe</option>
                            <option value="luxury">Luxury</option>
                            <option value="premium">Premium</option>
                          </select>
                        </div>
                        <div className="w-half">
                          <label htmlFor="">
                            Bed Type <span className="required">*</span>
                          </label>
                          <select
                            name="bed_type_information"
                            onChange={handleInputChange}
                            id=""
                            style={
                              formErrors.bed_type_information && {
                                backgroundColor: "#ff000040",
                                border: "1px solid red",
                              }
                            }
                          >
                            <option value="">Select option</option>
                            <option value="Futon">Futon</option>
                            <option value="King">King</option>
                            <option value="Murphy Bed">Murphy Bed</option>
                            <option value="Queen">Queen</option>
                            <option value="Sofa Bed">Sofa Bed</option>
                            <option value="Tatami Mats">Tatami Mats</option>
                            <option value="Twin">Twin</option>
                            <option value="Single">Single</option>
                            <option value="Full">Full</option>
                            <option value="Run of the House">Run of the House</option>
                            <option value="Dorm Bed">Dorm Bed</option>
                          </select>
                        </div>
                      </div>
                      {/* <div className='w-half'>
                                <label htmlFor="">Total Rooms  <span className='required'>*</span></label>
                                <input type="number" name='total_rooms' value={propertyData.total_rooms} onChange={handleInputChange} />
                            </div> */}
                      {/* <div className="w-half">
                <label htmlFor="">
                  Room View <span className="required">*</span>
                </label>
                <select
                  name="room_view"
                  value={roomData.room_view}
                  onChange={handleInputChange}
                  id=""
                  style={
                    formErrors.room_view && {
                      backgroundColor: "#ff000040",
                      border: "1px solid red",
                    }
                  }
                >
                  <option value="">Select option</option>
                  <option value="Park View">Pool View</option>
                  <option value="Valley View">Valley View</option>
                  <option value="No View">No View</option>
                  <option value="Sea View">Sea View</option>
                  <option value="Hill View">Hill View</option>
                  <option value="Pool View">Pool View</option>
                  <option value="Garden View">Garden View</option>
                  <option value="River View">River View</option>
                  <option value="Lake View">Lake View</option>
                  <option value="Palace View">Palace View</option>
                  <option value="Bay View">Bay View</option>
                  <option value="Jungle View">Jungle View</option>
                  <option value="City View">City View</option>
                  <option value="Landmark View">Landmark View</option>
                  <option value="Terrace View">Terrace View</option>
                  <option value="Lake View">Courtyard View</option>
                  <option value="Desert View">Desert View</option>
                  <option value="Golf Course View">Golf Course View</option>
                  <option value="Mountain View">Mountain View</option>
                  <option value="Ocean View">Ocean View</option>
                  <option value="Backwater View">Backwater View</option>
                  <option value="Resort View">Resort View</option>
                  <option value="Desert View">Desert View</option>
                  <option value="Golf Course View">Golf Course View</option>
                  <option value="Mountain View">Mountain View</option>
                  <option value="Lagoon View">Lagoon View</option>
                  <option value="Forest View">Forest View</option>
                  <option value="Beach View">Beach View</option>
                  <option value="Airport View">Airport View</option>
                  <option value="Countryside View">Countryside View</option>
                  <option value="Harbor View">Harbor View</option>
                  <option value="Inter-coastal View">Inter-coastal View</option>
                  <option value="Marina View">Marina View</option>
                </select>
              </div> */}
                      <div className="input-flex mt-10">
                        <div className="w-half">
                          <label htmlFor="">
                            Room Size <span className="required">*</span>
                          </label>
                          <input
                            type="number"
                            name="room_size_information"
                            value={roomData.room_size_information}
                            onChange={handleInputChange}
                            style={
                              formErrors.room_size_information && {
                                backgroundColor: "#ff000040",
                                border: "1px solid red",
                              }
                            }
                          />
                        </div>
                        <div className="w-half">
                          <label htmlFor="">
                            Unit <span className="required">*</span>
                          </label>
                          <select
                            name="room_area_information"
                            onChange={handleInputChange}
                            id=""
                            style={
                              formErrors.room_area_information && {
                                backgroundColor: "#ff000040",
                                border: "1px solid red",
                              }
                            }
                          >
                            <option value="">Select option</option>
                            <option value="sqmt">square meter</option>
                            <option value="sqft">square feet</option>
                          </select>
                        </div>
                        {/* <div className="w-half">
                          <label htmlFor="">
                            Status <span className="required">*</span>
                          </label>
                          <select
                            name="status"
                            onChange={handleInputChange}
                            id=""
                            style={
                              formErrors.status && {
                                backgroundColor: "#ff000040",
                                border: "1px solid red",
                              }
                            }
                          >
                            <option value="">Select option</option>
                            <option value="1">Active</option>
                            <option value="0">Draft</option>
                          </select>
                        </div> */}
                      </div>
                      <div className="mt-10">
                        <label htmlFor=""> Description</label>
                        <textarea
                          name="content"
                          value={roomData.content}
                          onChange={handleInputChange}
                          id=""
                          className="w-full mt-10 vendor_description_textarea"
                          placeholder="Type here..."
                          style={
                            formErrors.content && {
                              backgroundColor: "#ff000040",
                              border: "1px solid red",
                            }
                          }
                        ></textarea>
                      </div>{" "}
                    </div>
                    <div className="bg-white-div mt-10">
                      <div className="">
                        <h4>Occupancy</h4>

                        {/* <div className='w-half'>
                                    <label htmlFor="">Min LOS</label>
                                    <input type="text" onChange={handleInputChange} name='min_los' value={roomData.min_los} />
                                </div> */}
                        {/* <div className='w-half'>
                                    <label htmlFor=""> Max LOS <span className='required'>*</span></label>
                                    <input type="text" onChange={handleInputChange} name='max_los' value={roomData.max_los} required />
                                </div> */}
                        <div className="input-flex mt-10">
                          <div className="w-half">
                            <label htmlFor="">
                              Base Adult <span className="required">*</span>
                            </label>
                            <input
                              type="number"
                              onChange={handleInputChange}
                              name="base_adult"
                              value={roomData.base_adult}
                              style={
                                formErrors.base_adult && {
                                  backgroundColor: "#ff000040",
                                  border: "1px solid red",
                                }
                              }
                            />
                          </div>
                          <div className="w-half">
                            <label htmlFor="">
                              Max Adult <span className="required">*</span>
                            </label>
                            <input
                              type="number"
                              onChange={handleInputChange}
                              name="max_adult"
                              value={roomData.max_adult}
                              style={
                                formErrors.max_adult && {
                                  backgroundColor: "#ff000040",
                                  border: "1px solid red",
                                }
                              }
                            />
                          </div>
                          <div className="w-half">
                            <label htmlFor=""> Max Child</label>
                            <input
                              type="number"
                              onChange={handleInputChange}
                              name="max_child"
                              value={roomData.max_child}
                              style={
                                formErrors.max_child && {
                                  backgroundColor: "#ff000040",
                                  border: "1px solid red",
                                }
                              }
                            />
                          </div>
                          <div className="w-half">
                            <label htmlFor="">Max Occupancy</label>
                            <input
                              type="number"
                              onChange={handleInputChange}
                              name="max_occupancy"
                              value={roomData.max_occupancy}
                              style={
                                formErrors.max_occupancy && {
                                  backgroundColor: "#ff000040",
                                  border: "1px solid red",
                                }
                              }
                            />
                          </div>
                        </div>
                        {/* <h6 className='mt-10'>Price Per Night</h6>
                            <div className='flex flex_gap_10 w-full'>
                                <div className='w-half'>
                                    <label htmlFor="">EP</label>
                                    <input type="text" onChange={(e) => handleChange(e, "price_per_night", "ep")} name='ep' value={roomData['price_per_night']['ep']} />
                                </div>
                                <div className='w-half'>
                                    <label htmlFor="">CP</label>
                                    <input type="text" onChange={(e) => handleChange(e, "price_per_night", "cp")} name='ap' value={roomData['price_per_night']['cp']} />
                                </div>
                                <div className='w-half'>
                                    <label htmlFor=""> MAP</label>
                                    <input type="text" onChange={(e) => handleChange(e, "price_per_night", "map")} name='ap' value={roomData['price_per_night']['map']} />
                                </div>
                                <div className='w-half'>
                                    <label htmlFor=""> AP</label>
                                    <input type="text" onChange={(e) => handleChange(e, "price_per_night", "ap")} name='ap' value={roomData['price_per_night']['ap']} />
                                </div>
                            </div> */}
                        {/* <h6 className='mt-10'>Extra Adult Cost</h6>
                            <div className='flex flex_gap_10 w-full'>
                                <div className='w-half'>
                                    <label htmlFor="">EP</label>
                                    <input type="text" onChange={(e) => handleChange(e, "extra_adult_cost", "ep")} name='ep' value={roomData['extra_adult_cost']['ep']} />
                                </div>
                                <div className='w-half'>
                                    <label htmlFor="">CP</label>
                                    <input type="text" onChange={(e) => handleChange(e, "extra_adult_cost", "cp")} name='cp' value={roomData['extra_adult_cost']['cp']} />
                                </div>
                                <div className='w-half'>
                                    <label htmlFor=""> MAP</label>
                                    <input type="text" onChange={(e) => handleChange(e, "extra_adult_cost", "map")} name='map' value={roomData['extra_adult_cost']['map']} />
                                </div>
                                <div className='w-half'>
                                    <label htmlFor=""> AP</label>
                                    <input type="text" onChange={(e) => handleChange(e, "extra_adult_cost", "ap")} name='ap' value={roomData['extra_adult_cost']['ap']} />
                                </div>
                            </div> */}
                        {/* <h6 className='mt-10'>Child With Bed Cost</h6>
                            <div className='flex flex_gap_10 w-full'>
                                <div className='w-half'>
                                    <label htmlFor="">EP</label>
                                    <input type="text" onChange={(e) => handleChange(e, "child_with_bed_cost", "ep")} name='ep' value={roomData['child_with_bed_cost']['ep']} />
                                </div>
                                <div className='w-half'>
                                    <label htmlFor="">CP</label>
                                    <input type="text" onChange={(e) => handleChange(e, "child_with_bed_cost", "cp")} name='cp' value={roomData['child_with_bed_cost']['cp']} />
                                </div>
                                <div className='w-half'>
                                    <label htmlFor=""> MAP</label>
                                    <input type="text" onChange={(e) => handleChange(e, "child_with_bed_cost", "map")} name='map' value={roomData['child_with_bed_cost']['map']} />
                                </div>
                                <div className='w-half'>
                                    <label htmlFor=""> AP</label>
                                    <input type="text" onChange={(e) => handleChange(e, "child_with_bed_cost", "ap")} name='ap' value={roomData['child_with_bed_cost']['ap']} />
                                </div>
                            </div> */}
                        {/* <h6 className='mt-10'>Child Without Bed Cost</h6>
                            <div className='flex flex_gap_10 w-full'>
                                <div className='w-half'>
                                    <label htmlFor="">EP</label>
                                    <input type="text" onChange={(e) => handleChange(e, "child_without_bed_cost", "ep")} name='ep' value={roomData['child_without_bed_cost']['ep']} />
                                </div>
                                <div className='w-half'>
                                    <label htmlFor="">CP</label>
                                    <input type="text" onChange={(e) => handleChange(e, "child_without_bed_cost", "cp")} name='cp' value={roomData['child_without_bed_cost']['cp']} />
                                </div>
                                <div className='w-half'>
                                    <label htmlFor=""> MAP</label>
                                    <input type="text" onChange={(e) => handleChange(e, "child_without_bed_cost", "map")} name='map' value={roomData['child_without_bed_cost']['map']} />
                                </div>
                                <div className='w-half'>
                                    <label htmlFor=""> AP</label>
                                    <input type="text" onChange={(e) => handleChange(e, "child_without_bed_cost", "ap")} name='ap' value={roomData['child_without_bed_cost']['ap']} />
                                </div>
                            </div> */}
                      </div>
                    </div>
                    <div className="flex justify_content_end">
                      <button
                        type="submit"
                        className="vendor_common_property mt-10 mb-10 vendor_btn_hide_on_mobile"
                      >
                        Save Changes
                      </button>
                    </div>
                  </form>
                </div>

                <div className="new_ui_edit_page_sticky">
                  <div className="bg-white-div new-status-toggle-wrapper mt-10">
                    <label className="new-status-label">Status</label>
                    <label className="new-toggle-switch">
                      <input
                        type="checkbox"
                        checked={propertyStatus === "1"}
                        onChange={(e) => setPropertyStatus(e.target.checked ? "1" : "0")}
                      />
                      <span className="new-toggle-slider round"></span>
                    </label>
                  </div>

                  <div className="bg-white-div amenity_sec mt-10">
                    <h4 className="mb-10">Amenities</h4>
                    <div>
                      {Object.entries(allAmenitiesArray).map(([category, amenities]) => (
                        <div
                          key={category}
                          style={{ marginBottom: "10px", border: "1px solid #ccc" }}
                        >
                          {/* Accordion header */}
                          <div
                            onClick={() => handleAccordionToggle(category)}
                            style={{
                              fontSize: "14px",
                              cursor: "pointer",
                              padding: "10px",

                              color: openCategory === category ? "#009A50" : "black",
                              fontWeight: openCategory === category ? "bold" : "normal",
                            }}
                          >
                            {category}
                          </div>

                          {/* Conditional rendering of amenities */}
                          {openCategory === category && (
                            <div style={{ display: "flex", flexWrap: "wrap" }} className="new-rooms-amenities-div">
                              {amenities.map((amenity, index) => (
                                <div
                                  key={index}
                                  style={{
                                    margin: "5px",
                                    borderRadius: "5px",
                                    width: "150px",
                                    fontSize: "14px",
                                  }}
                                >
                                  <label >
                                    <input
                                      type="checkbox"
                                      checked={
                                        selectedAmenities[
                                          `${category}_amenities`
                                        ]?.includes(amenity.name) || false
                                      }
                                      onChange={() =>
                                        handleCheckboxChange(category, amenity.name)
                                      }
                                    />
                                    {amenity.name}
                                  </label>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

              </div>

            )}
          </div>
          <div className="flex justify_content_end">
            <button
              className="vendor_common_property mt-10 mb-10 vendor_btn_hide_on_desktop"
              onClick={addRoomDetails}
            >
              Save Changes
            </button>
          </div>
        </div>
      </div>
      {/* <AllAmenities showTitle={false} /> */}
    </section>
  );
}

export default AddRoomVendor;
